import React, { Component } from "react"
import PropTypes from "prop-types"
import { Dropdown, Image, Glyphicon } from "react-bootstrap"

import ClickAwayListener from "react-click-away-listener"
import Avatar from "react-avatar"

import iconDropdownDown from "../assets/icon-dropdown-down.svg"
import Constants from "../../../../Phi/Constants"

class HsgToggle extends Component {
    constructor(props) {
        super(props)

        this.handleToggleClick = this.handleToggleClick.bind(this)
    }

    render() {
        return (
            <div className="" onClick={this.handleToggleClick}>
                {this.props.children}
            </div>
        )
    }

    handleToggleClick(e) {
        e.preventDefault()
        this.props.onClick(e)
    }
}

class HsgMenu extends Component {
    render() {
        return (
            <div className="dropdown-menu-custom-header hsg-header-drop-down-menu-default" onClick={this.props.onClick}>
                {this.props.children}
            </div>
        )
    }
}

export default class UserProfileDropdown extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showMenu: false,
        }

        this.handleToggle = this.handleToggle.bind(this)
        this.onClickMenu = this.onClickMenu.bind(this)
    }

    componentDidMount() {
        this.setState({ profilePic: Constants.formatProfilePicURL(this.props.profilePic) })
    }

    componentDidUpdate(oldProps) {
        if (this.props.profilePic !== oldProps.profilePic && this.props.profilePic) {
            this.setState({ profilePic: Constants.formatProfilePicURL(this.props.profilePic) })
        }
    }

    menuElementChildList = (child, selected, updateSelectedChild) =>
        child.map((element, index) => {
            let isSelected = index === selected

            return (
                <div className="hsg-header-dropdown-menu-option" key={index} onClick={() => updateSelectedChild(index)}>
                    <Avatar round={true} size={38} name={element.name} />
                    <div
                        className={`hsg-header-user-profile-child-list-name ${
                            isSelected ? "hsg-header-user-profile-child-list-name-selected" : "hsg-header-user-profile-child-list-name-default"
                        }`}
                    >
                        {element.name}
                    </div>
                </div>
            )
        })

    menuElementLogout = (icon, label) => (
        <div>
            <div className="hsg-header-dropdown-menu-option hsg-header-dropdown-menu-option-last" onClick={() => this.props.onClickLogout()}>
                <span className="hsg-header-dropdown-icon glyphicon glyphicon-off" />
                <span className="hsg-header-dropdown-text">{label}</span>
            </div>
        </div>
    )

    menuElementProfile = (label) => (
        <div>
            <div className="hsg-header-dropdown-menu-option" onClick={() => this.props.onClickProfile()}>
                <i style={{ fontSize: 20 }} className="hsg-header-dropdown-icon fa fa-user" aria-hidden="true"></i>
                <span style={{ marginLeft: 10 }} className="hsg-header-dropdown-text">
                    {label}
                </span>
            </div>
        </div>
    )

    render() {
        let { name, profilePic, childList, childCurrent, updateSelectedChild } = this.props

        let trimName = name.split(' ')
        trimName = trimName[0]

        return (
            <ClickAwayListener onClickAway={() => this.setState({ showMenu: false })}>
                <Dropdown id="hsg-header-user-dropdown" open={this.state.showMenu} onToggle={this.handleToggle}>
                    {/* <Dropdown id="hsg-header-user-dropdown" open={this.state.showMenu}> */}
                    <HsgToggle bsRole="toggle">
                        <div className="hsg-header-main-profile-group">
                            <Avatar className="hsg-header-user-profile-image" size={38} name={name} src={this.state.profilePic} round />
                            <div className="hsg-header-user-profile-content">{trimName}</div>
                            <img className="hsg-header-main-profile-icon" src={iconDropdownDown}></img>
                        </div>
                    </HsgToggle>

                    <HsgMenu bsRole="menu" onClick={this.onClickMenu}>
                        {/* <HsgMenu bsRole="menu"> */}

                        {this.menuElementProfile("My Profile")}
                        {this.menuElementChildList(childList, childCurrent, updateSelectedChild)}
                        {this.menuElementLogout("log-out", "Logout")}
                    </HsgMenu>
                </Dropdown>
            </ClickAwayListener>
        )
    }

    handleToggle() {
        const status = !this.state.showMenu
        this.setState({ showMenu: status })
    }

    onClickMenu() {
        this.setState({ showMenu: false })
    }
}
